import { QueryClient } from '@tanstack/react-query';
import { clearClientPreferenceOptionsCache } from '@/lib/clientPreferenceOptions';

export const queryClient = new QueryClient();

export const clearAppQueryCache = () => {
  queryClient.clear();
  clearClientPreferenceOptionsCache();
};
